import { render, staticRenderFns } from "./Bidding.vue?vue&type=template&id=178863c3&scoped=true&"
import script from "./Bidding.vue?vue&type=script&lang=ts&"
export * from "./Bidding.vue?vue&type=script&lang=ts&"
import style0 from "./Bidding.vue?vue&type=style&index=0&id=178863c3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178863c3",
  null
  
)

export default component.exports